import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from '../../../services/Auth';

class UserVacanciesApi extends Api {
  constructor() {
    super('cv/user_vacancies/');
  }
  approve(id, data) {
    return this.buildQuery(
      'post',
      {
        data,
      },
      `${id}/approve`,
    );
  }
  approveUserVacancy(id, params) {
    this.buildQuery('post', params, `${id}/approve`);
  }

  createUserVacancy(params) {
    this.buildQuery('post', {
      user_vacancy: {
        status: params.status,
        doc: {
          filename: params.filename,
          type: params.type,
          name: 'user_vacancy[doc]',
          tempfile: params.file,
          head: `Content-Disposition: form-data; name="user_vacancy[doc]"; filename="${params.filename}"\r\nContent-Type: ${params.type}\r\nContent-Length: ${params.size}\r\n`,
        },
      },
    });
  }

  createVacanice(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      '',
    );
  }

  update(id, data) {
    return this.buildQuery(
      'put',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      id,
    );
  }

  getPDF(url) {
    return axios({
      url,
      method: 'get',
      data: {},
      params: {},
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default UserVacanciesApi;
